/** Marcas diacríticas combinantes (U+0300–U+036F). */
const DIACRITICOS = /[\u0300-\u036f]/g;

/**
 * Texto de búsqueda normalizado: sin acentos, sin mayúsculas y sin espacios en
 * los extremos ("Envíos" se encuentra escribiendo "envios"). Puro; lo comparten
 * el buscador de productos y el de empresas SPEI de `/products` (feature 152).
 */
export function normalizeSearchText(valor: string): string {
  return String(valor ?? '').normalize('NFD').replace(DIACRITICOS, '').trim().toLowerCase();
}

/** Tope del término de un buscador de `/products` (diseño §7). */
export const SEARCH_TERM_MAX_LENGTH = 60;

/** Término tal como viaja o se aplica: recortado y a 60 caracteres como mucho. */
export function boundedSearchTerm(valor: string): string {
  return String(valor ?? '').trim().slice(0, SEARCH_TERM_MAX_LENGTH);
}
